module.exports = __webpack_public_path__ + "img/404.a1bd8d7c.png";